import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './index.css';
// react-day-picker's stylesheet, loaded by the app rather than by
// `@resource-kit/ui`'s `Calendar` (#2169 PR-1). A package cannot own a global
// side effect: the import would fire for anyone who touched the module graph,
// and the boundary gate reads a bare CSS specifier as an undeclared dependency.
import 'react-day-picker/dist/style.css';
import App from './App';
import { BetterAuthProvider } from './hooks/useAuth';
import { registerFeatureWidgets } from './features/widgets';
import { registerFeatureRelations } from './features/relations';

// Composition root: widgets and relation targets are registered by EXPLICIT
// calls, exactly once, before anything can resolve one. See
// `src/features/widgets.ts` and `src/features/relations.ts`.
registerFeatureWidgets();
registerFeatureRelations();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BetterAuthProvider>
        <App />
      </BetterAuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
